{
  "apply": "Appliquer ({count})",
  "buttonLabel": "Filtres",
  "close": "Fermer",
  "deleteSelectedFilter": "Supprimer le filtre sélectionné",
  "header": "Filtres",
  "searchByName": "Recherche par nom",
  "model": "Gamme",
  "type": "Type",
  "clearFilters": "Supprimer les filtres",
  "connectivity": "Connectivité",
  "certificate": "Certificat",
  "state": "État",
  "certificateValidity": {
    "title": "Validité du certificat",
    "expired": "Expiré",
    "validityUnder1": "Valide < 1 mois",
    "validityUnder3": "Valide < 3 mois",
    "validityUnder6": "Valide < 6 mois",
    "validityAfter6": "Valide > 6 mois",
    "label": "date d’expiration certificat"
  },
  "validityInMonth": "La validité sélectionnée est en mois",
  "range": "Gamme",
  "creationDate": {
    "label": "Date d’ajout",
    "formatter": {
      "input": "YYYY-MM-DD",
      "tag": "DD/MM/YYYY"
    },
    "periodSeparator": "au",
    "placeholder": "Sélectionner une période"
  },
  "selectCreationDate": "Sélectionner la date",
  "date": {
    "to": "au",
    "startPlaceholder": "Date de début",
    "endPlaceholder": "Date de fin",
    "formatter": {
      "tag": "DD/MM/YYYY"
    },
    "periodSeparator": "au",
    "period": {
      "placeholder": "Sélectionner une période",
      "separator": "au"
    }
  },
  "resetFilter": "Supprimer le filtre | Supprimer les filtres",
  "validateFilter": "Valider le filtre",
  "searchDevice": "Rechercher des équipements",
  "sector": "Secteur",
  "searchOperations": "Rechercher des opérations",
  "searchByLastNameOrFirstName": "Rechercher par nom ou prénom",
  "search": "Rechercher",
  "status": "État",
  "firmware": {
    "range": "Type d’équipements"
  },
  "connectivityState": {
    "active": "Connecté",
    "inactive": "Inactif"
  }
}
